import { PrismicNextImage } from '@prismicio/next';
import { FC } from 'react';
import { ChallengeSliceChallengeAndSolution } from '../../../../prismicio-types';

interface ChangeAndSolutionProps {
  slice: ChallengeSliceChallengeAndSolution;
}

const ChallengeAndSolution: FC<ChangeAndSolutionProps> = (props) => {
  const {
    title,
    industry,
    challenge: challengeText,
    solution: solutionText,
  } = props.slice.primary;
  const {
    imagereference: referenceImage,
    teamrole: teamInvolved,
    techstack: techStack,
  } = props.slice.primary;

  return (
    <div className="bg-gradient-to-b from-[#0F3932] to-[#0E1110] text-white font-inter pt-16">
      <div className="container mx-auto grid grid-cols-2 md:grid-cols-4 gap-[60px] px-6">
        <div className="flex flex-col col-span-4 md:col-span-3 gap-[60px]">
          <div className="flex flex-col gap-6">
            <h2 className="text-[40px] font-semibold">The Challenge</h2>
            <p className="text-lg text-white/80 font-inter">{challengeText}</p>
          </div>
          <div className="flex flex-col gap-6">
            <h2 className="text-[40px] font-semibold">The Solution</h2>
            <p className="text-lg text-white/80 font-inter">{solutionText}</p>
            <PrismicNextImage
              field={referenceImage}
              className="w-full object-contain"
            />
          </div>
        </div>
        <div className="col-span-4 md:col-span-1">
          <div
            style={{
              background:
                'linear-gradient(to right, rgba(255,255,255,0.15), rgba(3,191,158,0.15), rgba(255,255,255,0.15))',
            }}
            className="font-manrope flex flex-col gap-6 p-6 rounded-[24px]"
          >
            <div className="flex flex-col gap-2">
              <div className="font-bold text-xl">Client</div>
              <div className="font-normal">{title}</div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="font-bold text-xl">Industry</div>
              <div className="font-normal text-lg">{industry}</div>
            </div>
            {teamInvolved.length > 0 && (
              <div className="flex flex-col gap-2">
                <div className="font-bold text-xl leading-[140%]">
                  Team Involved
                </div>
                <div className="font-normal text-lg leading-[150%]">
                  {teamInvolved.map((member, index) => (
                    <>
                      <span key={index}>{member.role}</span>{' '}
                      {index !== 0 && <br />}
                    </>
                  ))}
                </div>
              </div>
            )}
            {techStack.length > 0 && (
              <div className="flex flex-col gap-2">
                <div className="font-bold text-xl leading-[140%]">
                  Tech Stack
                </div>
                <div className="flex flex-col gap-2 items-start">
                  {techStack.map((tech, index) => (
                    <figure key={index}>
                      <PrismicNextImage
                        field={tech.icon}
                        className="w-24 h-8"
                      />
                    </figure>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeAndSolution;
